/**
 * @module constants/colors
 * @description 颜色常量 — 从 ChartsDrop/components/MapColorSelector/constants 提取
 *
 * 用途：
 * - MapChart.tsx 引用 COLORS_MAP
 *
 * @see docs/DVA环境迁移执行计划.md §N6
 */

export const COLORS_MAP = {
  blue: {
    value: 'blue',
    nameId: 'dbl_chart_map_color_blue',
    colors: ['#F0F7FF', '#CFE4FF', '#A6C9FF', '#7DADFF', '#5086F3'],
  },
  yellow: {
    value: 'yellow',
    nameId: 'dbl_chart_map_color_yellow',
    colors: ['#FFFDE8', '#FFF9BF', '#FFF196', '#FFE76E', '#F5D242'],
  },
  green: {
    value: 'green',
    nameId: 'dbl_chart_map_color_green',
    colors: ['#F0FFF5', '#E9F7EE', '#C0EBD2', '#92DEB4', '#69D19C'],
  },
  red: {
    value: 'red',
    nameId: 'dbl_chart_map_color_red',
    colors: ['#FFF1F0', '#FFE6E6', '#FFD4D4', '#FFABAF', '#F17C86'],
  },
  custom: {
    value: 'custom',
    nameId: 'dbl_chart_map_color_custom',
    colors: ['#F2F3F5', '#F2F3F5', '#F2F3F5', '#F2F3F5', '#F2F3F5'],
  },
} as const;
